// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgk_a bhj_vf bhj_a bhj_q bhj_k","AdSlotMail__mail--notLoaded":"bgk_b bhj_eu bhj_bj bhj_vu","show-ad-not-loaded":"bgk_c","AdSlotMail__cta":"bgk_e"};